<template>
        <div class="border-radius-main p-5 shadow-2 pointer h-100">
            <div class="store-container h-100 d-flex flex-column align-items-start">
                <div class="d-flex mb-1 align-items-center">
                    <h5 class="store-content store-title font-regular  h4">{{ item.title }}</h5>
                    <p class="ps-2 distance d-inline-block small" v-if="item.distance.text!==''">({{ item.distance.text }})</p>
                </div>
                <a :href="`tel:${item.phone}`" class="store-content store-phone mb-1 bg-secondary-l p-1 line-1 border-radius-main">
                  <font-awesome-icon class="me-2" icon="phone-alt"/>
                  {{ item.phone }}
                </a>
                <div class="store-content store-address text-s">{{ item.address }}</div>
                <div class="store-content store-locality text-s mb-2">{{ item.zip }} {{ item.city }}</div>
                <div class="field-store-status" v-html="nearestStatus"></div>
                <div class="pt-2 mt-auto d-flex align-items-center flex-wrap">
                    <a :href="item.path" class="store-btn zur-btn me-1 mt-1 d-inline-block position-relative btn btn-primary">
                      <font-awesome-icon class="me-2" icon="map-marker-alt"/>
                      {{ text.to_store }}
                    </a>
                    <a :href="eterminPath" class="store-btn termin-btn mt-1 d-inline-block  position-relative btn btn-secondary"  v-if="item.calenderid">
                      <font-awesome-icon class="me-2" icon="calendar-week"/>
                      {{ text.book }}
                    </a>
                </div>
            </div>
        </div>
</template>

<script>
import { buildStatus } from '@/services/StoreStatus.js'
import ServiceDrupal from '@/services/ServiceDrupal.js'

export default {
    name: 'nearest',
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        eterminPath () {
            return `${this.item.path}#etermin-app`
        }
    },
    data () {
        return {
            text: {
                to_store: Drupal.t('To the store'),
                book: Drupal.t('Book an appointment')
            },
            nearestStatus: `<div class='loading-status mb-1'></div>`,
            StatusCreated: 0
        }
    },
    methods: {},
    async mounted () {
        let data = {
            opening_hours: JSON.parse(this.item.openinghours),
            lunch_break: JSON.parse(this.item.lunchbreak),
            federal_state: this.item.federalstate,
            special_hours: JSON.parse(this.item.specialbushours)
        }
        this.nearestStatus = await buildStatus(data, 'l')
    }
}
</script>
